import { OpsCorrectionQueue } from 'codegen';
import { TColumn } from 'types';

import { StartCorrection } from '../components';

export const columns: TColumn<OpsCorrectionQueue>[] = [{
  title: 'ID',
  dataIndex: 'id',
}, {
  title: 'Name',
  dataIndex: 'name',
}, {
  title: 'Description',
  dataIndex: 'description',
}, {
  title: 'Snap Amount',
  dataIndex: 'snapAmount',
}, {
  width: 160,
  title: 'Actions',
  render: (_, { id }) => <StartCorrection queueId={id} />,
}];
